function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import cn from 'clsx';
import { string, shape } from 'prop-types';
import Image from '../../atoms/Image/index.jsx';
import SearchForm from '../../molecules/SearchForm/index.jsx';
import PopupContext from '../../context/PopupContext.js';

/**
 * BrandedSection component.
 */
const BrandedSection = ({
  logo,
  logoAlignment,
  strapline,
  search,
  className,
  logoUrl,
  backgroundImage
}) => {
  const {
    activePopup,
    popupKeys
  } = useContext(PopupContext);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('branded-section', className, activePopup === popupKeys.search && 'branded-section--show-mobile-search', backgroundImage && 'branded-section--with-sponsored'),
    id: `${popupKeys.search}-popup`
  }, /*#__PURE__*/React.createElement("div", {
    className: "branded-section__container container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "branded-section__brand " + (logoAlignment === 'centre' ? 'col-lg-12' : 'col-lg-8')
  }, logo && /*#__PURE__*/React.createElement(Image, _extends({
    maxHeight: 65,
    maxWidth: 600,
    srcSetBreakpoints: [300, 375, 450, 650, 900, 1100, 1400, 1800 // Up to 3x the max width of the image
    ],

    sizes: ['600px'],
    fluid: true,
    link: {
      href: logoUrl,
      rel: 'home'
    }
  }, logo, {
    loading: "eager",
    className: logoAlignment === 'centre' ? 'ml-auto mr-auto' : null
  })), strapline && /*#__PURE__*/React.createElement("small", {
    className: 'branded-section__strapline' + (logoAlignment === 'centre' ? " text-center" : "")
  }, strapline)), logoAlignment !== 'centre' && search && /*#__PURE__*/React.createElement(SearchForm, {
    className: "col-lg-4 branded-section__search hidden-print",
    inputId: "branded-section-search-input",
    focusInput: activePopup === popupKeys.search,
    mobileSquareBorders: true,
    url: search.url,
    query: search.query,
    placeholder: search.placeholder,
    isAutocomplete: search.isAutocomplete,
    dataPlacement: "HeaderBrandAreaRight"
  }))));
};
BrandedSection.defaultProps = {
  logo: null,
  logoAlignment: null,
  className: null,
  strapline: null,
  search: null,
  logoUrl: '/',
  backgroundImage: null
};
BrandedSection.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The brand logo. */
  logo: shape(Image.propTypes),
  /** The alignment of the brand logo. */
  logoAlignment: string,
  /** Additional class names to add to the component root. */
  className: string,
  /** Strapline under the brand logo.  */
  strapline: string,
  /** The search settings. */
  search: shape(SearchForm.propTypes),
  /** The URL to the home page. */
  logoUrl: string,
  /** The URL for the header background image */
  backgroundImage: string
} : {};
export default BrandedSection;